export default __webpack_public_path__ + "static/media/kimbal.b0fe15e9.jpg";